import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authAPI } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { apiError, goTo, tenantUrl } from '../lib/host';
import '../components/Layout.css';
import AuthShell from '../components/AuthShell';
import './Auth.css';

export default function CreateOrganization() {
  const { canCreateOrg } = useAuth();
  const [params] = useSearchParams();
  const [name, setName] = useState(params.get('name') || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await authAPI.createTenant(name);
      goTo(tenantUrl(res.data.tenant.slug, '/subscription'));
    } catch (err) {
      setError(apiError(err, 'Could not create the company'));
      setLoading(false);
    }
  };

  if (!canCreateOrg) {
    return (
      <AuthShell>
        <h2>New company</h2>
        <div className="error-message">
          You already own a company. Each account can create one company; contact support if you need another.
        </div>
        <p className="auth-link"><Link to="/select-org">Back to my companies</Link></p>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <h2>New company</h2>
      <p className="tcx-muted" style={{ marginBottom: 16 }}>
        It gets its own isolated database. You'll be its owner.
      </p>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="org_name">Company name</label>
          <input
            id="org_name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            disabled={loading}
          />
        </div>
        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? 'Provisioning...' : 'Create company'}
        </button>
      </form>
      <p className="auth-link"><Link to="/select-org">Back to my companies</Link></p>
    </AuthShell>
  );
}
